import { BillingStatusDto } from '../generated'

// Mirrors ClubBillingService.GOOD_SUBSCRIPTION_STATUSES on the back-end
const GOOD_SUBSCRIPTION_STATUSES = ['trialing', 'active', 'past_due']

export const isInGoodStanding = (billing: BillingStatusDto): boolean =>
  billing.billingExempt ||
  GOOD_SUBSCRIPTION_STATUSES.includes(billing.subscriptionStatus ?? '')
